import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const ClientForm = ({ formData, errors, onChange }) => {
  const businessTypeOptions = [
    { value: 'sole_proprietor', label: 'Eenmanszaak' },
    { value: 'bv', label: 'BV (Besloten Vennootschap)' },
    { value: 'nv', label: 'NV (Naamloze Vennootschap)' },
    { value: 'vof', label: 'VOF (Vennootschap onder Firma)' },
    { value: 'foundation', label: 'Stichting' },
    { value: 'association', label: 'Vereniging' },
    { value: 'other', label: 'Anders' }
  ];

  const servicePreferenceOptions = [
    { value: 'solar', label: 'Zonnepanelen' },
    { value: 'heat_pump', label: 'Warmtepompen' },
    { value: 'hvac', label: 'HVAC Systemen' },
    { value: 'electrical', label: 'Elektrische Installatie' },
    { value: 'maintenance', label: 'Onderhoud' },
    { value: 'ventilation', label: 'Ventilatie' },
    { value: 'smart_home', label: 'Smart Home' }
  ];

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Building2" size={20} />
          Bedrijfsgegevens
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Bedrijfsnaam"
            type="text"
            placeholder="Uw bedrijfsnaam"
            value={formData?.companyName || ''}
            onChange={(e) => onChange('companyName', e?.target?.value)}
            error={errors?.companyName}
            required
          />

          <Select
            label="Type Bedrijf"
            options={businessTypeOptions}
            value={formData?.businessType}
            onChange={(value) => onChange('businessType', value)}
            placeholder="Selecteer bedrijfstype"
            error={errors?.businessType}
            required
          />

          <Input
            label="KVK Nummer"
            type="text"
            placeholder="12345678"
            value={formData?.businessRegistration || ''}
            onChange={(e) => onChange('businessRegistration', e?.target?.value)}
            description="Kamer van Koophandel nummer"
            error={errors?.businessRegistration}
          />

          <Input
            label="BTW Nummer"
            type="text"
            placeholder="NL123456789B01"
            value={formData?.vatNumber || ''}
            onChange={(e) => onChange('vatNumber', e?.target?.value)}
            description="Optioneel"
            error={errors?.vatNumber}
          />
        </div>
      </div>

      <div className="border-t border-border pt-6 space-y-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="MapPin" size={20} />
          Locatie en Contact
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Telefoonnummer"
            type="tel"
            placeholder="+31 6 12345678"
            value={formData?.phone || ''}
            onChange={(e) => onChange('phone', e?.target?.value)}
            error={errors?.phone}
            required
          />

          <Input
            label="Locatie"
            type="text"
            placeholder="Amsterdam, Nederland"
            value={formData?.location || ''}
            onChange={(e) => onChange('location', e?.target?.value)}
            description="Stad of regio"
            error={errors?.location}
            required
          />
        </div>

        <Input
          label="Factuuradres"
          type="text"
          placeholder="Straatnaam 123, 1234 AB Amsterdam"
          value={formData?.billingAddress || ''}
          onChange={(e) => onChange('billingAddress', e?.target?.value)}
          error={errors?.billingAddress}
        />
      </div>

      <div className="border-t border-border pt-6 space-y-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Settings" size={20} />
          Voorkeuren
        </h3>
        
        <Select
          label="Dienst Voorkeuren"
          options={servicePreferenceOptions}
          value={formData?.servicePreferences || []}
          onChange={(value) => onChange('servicePreferences', value)}
          multiple
          searchable
          placeholder="Selecteer diensten waarin u geïnteresseerd bent"
          description="Selecteer de diensten waarvoor u vakmensen zoekt"
          error={errors?.servicePreferences}
        />
      </div>
    </div>
  );
};

export default ClientForm;